import {
    REQUEST_STATE,

    CORE_GET_ALL_COURSE_INCOMING_REQUEST,
    CORE_GET_ALL_COURSE_INCOMING_SUCCESS,
    CORE_GET_ALL_COURSE_INCOMING_FAILURE,

    CORE_GET_ALL_COURSE_HISTORY_REQUEST,
    CORE_GET_ALL_COURSE_HISTORY_SUCCESS,
    CORE_GET_ALL_COURSE_HISTORY_FAILURE,

    CORE_GET_COURSE_BY_ID_INCOMING_REQUEST,
    CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS,
    CORE_GET_COURSE_BY_ID_INCOMING_FAILURE,

} from '../types'

const requestState = REQUEST_STATE

export default {
    courseToJoins: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_COURSE_INCOMING_REQUEST:
            case CORE_GET_ALL_COURSE_HISTORY_REQUEST:
                return state
            case CORE_GET_ALL_COURSE_INCOMING_SUCCESS:
            case CORE_GET_ALL_COURSE_HISTORY_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload
                    if (result && datas) {
                        return datas
                    } else return []
                } else {
                    return []
                }
            case CORE_GET_ALL_COURSE_INCOMING_FAILURE:
            case CORE_GET_ALL_COURSE_HISTORY_FAILURE:
                return []
            default:
                return state
        }
    },
    courseToJoin: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_COURSE_BY_ID_INCOMING_REQUEST:
                return state
            case CORE_GET_COURSE_BY_ID_INCOMING_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload
                    if (result && data) {
                        return data
                    } else return {}
                } else {
                    return {}
                }
            case CORE_GET_COURSE_BY_ID_INCOMING_FAILURE:
                return {}
            default:
                return state
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/course.js